import React from "react"
import { locale } from "@albelli/photoselector"
import ArrowLeft from "../Graphic/left-black-arrow.svg"

interface NavigateBackProps {
  navigateTo: () => void
  title: string
}

const NavigateBack = (props: NavigateBackProps) => {
  const { navigateTo, title } = props

  return (
    <div className={"photoselector-photoorganiser-navigation "}>
      <div className="photoselector-photoorganiser-title-container">
        <div className="photoselector-back-button" onClick={navigateTo} data-tam="back-button">
          <img src={ArrowLeft} /> {locale.get().generic.back} |
        </div>
        <div className="photoselector-title" data-tam="back-button-title">
          {title}
        </div>
      </div>
    </div>
  )
}

export default NavigateBack
